$('body').on('click', '.chat-open-close', function() {
  $(this).toggleClass('showhidechat');
  if($(this).hasClass('showhidechat')) {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }
  else {
    window.tidioChatApi.show();
    window.tidioChatApi.close();
  }
});

$(function ($) {
$('.slider').slick({
  dots: true,
  infinite: true,
  arrows:false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false   
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
    }
  }]
});
 /*---------------- Shop Slider ------------------*/

  $('.prod-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite:false,
    fade: false,
    asNavFor: '.shop-slider-nav'
  });
  $('.shop-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.prod-slider',
    dots: false,
    arrows: true,
    focusOnSelect: true,    
    verticalSwiping:true,
    responsive: [

      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },     
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical:false
          // horizontal:true,


        }
      },
      { 
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false
        }
      }

    ]
  });
  });


  function mobile_shop_bar(para) {
    if(para==1) {
      $('.shop_side_bar_mobile').fadeIn(500);
    } else {
      $(".shop_side_bar_mobile").fadeOut(600);
    }
  }


